<!--========== 用户Ai权限配置管理 ==========-->
<template>
    <div class="app-container config-wrap">
        <!--左侧组织树-->
        <el-card class="org-tree-card">
            <div class="tree-title">组织</div>
            <el-tree
                ref="orgTree"
                :props="{ label: 'orgName', children: 'childrenList' }"
                node-key="orgId"
                highlight-current
                expand-on-click-node
                :default-expanded-keys="defaultExpandedKeys"
                :data="treeData"
                @node-click="handleNodeClick"
                @node-expand="handleNodeExpand">
                <template #default="{ data }">
                    <span class="node-label">
                        <img class="xj-icon cursor" :src="data.xjCode ? aiOpenColorIcon : aiOpenIcon" alt=""
                            @click.stop="handleEditOrg(data)">
                        <span>{{ data.orgName }}</span>
                    </span>
                </template>
            </el-tree>
        </el-card>
        <!--右侧用户查询分页-->
        <el-card class="user-list-card">
            <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px"
                @submit.native.prevent="handleQuery">
                <el-row class="mt15">
                    <el-col :span="18" class="mb0"></el-col>
                    <el-col :span="6" class="mr0 mb0">
                        <el-form-item class="pull-right">
                            <el-input v-model="queryParams.trueName" placeholder="请输入姓名或账号" class="input-with-select">
                                <template #append>
                                    <el-button @click="handleQuery" type="primary" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-divider />
            <div class="bre9e mt15">
                <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                    :height="`calc(100vh - 275px)`" v-loading="loading"
                    :data="dataList" highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column label="账号" width="120" prop="username" />
                    <el-table-column width="120" align="center" label="姓名" prop="trueName" />
                    <el-table-column label="所属组织" align="center" prop="orgName" />
                    <el-table-column label="AI教学助手" align="center" prop="isAiAide">
                        <template #default="scope">
                            <el-switch v-model="scope.row.isAiAide" :active-value="1" :inactive-value="0"
                                @change="handleAiConfigChange(scope.row, 'isAiAide')" />
                        </template>
                    </el-table-column>
                    <el-table-column label="超级教研员" align="center" prop="isAiInstructor">
                        <template #default="scope">
                            <el-switch v-model="scope.row.isAiInstructor" :active-value="1" :inactive-value="0"
                                @change="handleAiConfigChange(scope.row, 'isAiInstructor')" />
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="zdyfy">
                <pagination class="zdyfy" :background="false" :pageSizes="[10, 20, 30]"
                            v-show="total > 0"
                            :total="total"
                            v-model:page.sync="queryParams.pageNum"
                            v-model:limit.sync="queryParams.pageSize"
                            @pagination="getList" />
            </div>
        </el-card>
        <el-dialog draggable title="编辑组织信息" v-model="orgDialogShow" width="500px">
            <el-form ref="orgFormRef" :model="orgForm" :rules="orgRules" label-width="100px">
                <el-form-item label="组织名称" prop="orgName">
                    <el-input v-model="orgForm.orgName" placeholder="最多32个字" maxlength="32" />
                </el-form-item>
                <el-form-item label="璇玑Code">
                    <el-input v-model="orgForm.xjCode" placeholder="请输入璇玑Code" maxlength="64" />
                </el-form-item>
            </el-form>
            <template #footer>
                <div class="disflex-row-center">
                    <el-button type="primary" @click="submitOrgForm">确 定</el-button>
                    <el-button @click="orgDialogShow = false">取 消</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import { orgListUserOrg,openOrCancelAiAide,openOrCancelAiInstructor,orgUpdate } from "@/api/admin/system";
import { queryDict, userPageList } from "@/api/admin/public";
import aiOpenIcon from "@/assets/ai/ai_open.png";
import aiOpenColorIcon from "@/assets/ai/ai_open_color.png";

export default {
    name: "userConfig",
    data() {
        return {
            aiOpenIcon,
            aiOpenColorIcon,
            loading: true,
            total: 0,
            dataList: [],
            treeData: [],
            defaultExpandedKeys: [],
            userRoleList: [],
            teacherRankList: [],
            role: this.$storage.get("role"),
            queryParams: {
                orgId: '',
                trueName: '',
                gender: '',
                roleType: '',
                teacherRank: '',
                pageNum: 1,
                pageSize: 10,
            },
            orgDialogShow: false,
            orgForm: {
                orgId: '',
                orgName: '',
                orgType: '',
                adminUsername: '',
                adminUserId: '',
                orgNature: '',
                xjCode: '',
                beginTime: '',
                endTime: '',
                adminList: [],
                isAide: 0,
                isRwmy: 0,
                schoolPeriod: '',
                schoolPeriodList: [],
            },
            orgRules: {
                orgName: [
                    { required: true, message: "请输入组织名称", trigger: "blur" }
                ]
            },
        };
    },
    created() {
        this.getOrgListTree();
        this.getQueryDict();
        this.getList();
    },
    methods: {
        getOrgListTree() {
            orgListUserOrg().then(res => {
                this.treeData = res.data.data;
                if (this.treeData && this.treeData.length > 0 && this.defaultExpandedKeys.length == 0) {
                    this.defaultExpandedKeys = [this.treeData[0].orgId];
                }
            })
        },
        /** 点击AI图标维护组织信息 */
        handleEditOrg(data) {
            var row = JSON.parse(JSON.stringify(data));
            this.orgForm = {
                orgId: row.orgId,
                orgName: row.orgName,
                orgType: row.orgType,
                adminUsername: row.adminUsername,
                adminUserId: row.adminUserId,
                orgNature: row.orgNature,
                xjCode: row.xjCode || '',
                beginTime: row.beginTime,
                endTime: row.endTime,
                adminList: row.adminList || [],
                isAide: row.isAide ? row.isAide : 0,
                isRwmy: row.isRwmy ? row.isRwmy : 0,
                schoolPeriod: row.schoolPeriod,
                schoolPeriodList: row.schoolPeriod ? row.schoolPeriod.split(',') : [],
            };
            this.orgDialogShow = true;
        },
        submitOrgForm() {
            this.$refs.orgFormRef.validate(valid => {
                if (!valid) return;
                var obj = JSON.parse(JSON.stringify(this.orgForm));
                var adminList = [];
                obj.adminList.forEach(e => {
                    if (e.userId) {
                        adminList.push(e.userId)
                    }
                })
                obj.adminList = adminList;
                if (obj.schoolPeriodList.length != 0) {
                    obj.schoolPeriod = obj.schoolPeriodList.toString();
                }
                orgUpdate(obj).then(res => {
                    if (res.data.code == 1) {
                        this.$message.success("修改成功");
                        this.orgDialogShow = false;
                        this.getOrgListTree();
                    } else {
                        this.$message.error(res.data.msg || "操作失败");
                    }
                })
            })
        },
        /** 同级只展开一个顶级节点，展开一个时收起其他 */
        handleNodeExpand(data, node) {
            if (node.level !== 1) return;
            this.treeData.forEach(item => {
                if (item.orgId !== data.orgId) {
                    const n = this.$refs.orgTree.store.getNode(item.orgId);
                    if (n) n.expanded = false;
                }
            })
        },
        getQueryDict() {
            queryDict({ code: 'user_role' }).then(res => {
                this.userRoleList = res.data.data;
            })
            queryDict({ code: 'teacher_rank' }).then(res => {
                this.teacherRankList = res.data.data;
            })
        },
        /** 组织树节点点击 */
        handleNodeClick(data) {
            this.queryParams.orgId = this.queryParams.orgId == data.orgId ? '' : data.orgId;
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 查询用户列表 */
        getList(e) {
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            userPageList(this.queryParams).then(res => {
                this.loading = false;
                this.dataList = res.data.data.list;
                this.total = res.data.data.total;
            });
            
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** AI 权限开通/关闭（1 开通 0 关闭） */
        handleAiConfigChange(row, field) {
            const api = field == 'isAiAide' ? openOrCancelAiAide : openOrCancelAiInstructor;
            api({ userId: row.userId }).then(res => {
                if (res.data.code == 1) {
                    this.$message.success('操作成功');
                } else {
                    row[field] = row[field] == 1 ? 0 : 1;
                    this.$message.error(res.data.msg || '操作失败');
                }
            }).catch(() => {
                row[field] = row[field] == 1 ? 0 : 1;
            })
        },
    }
};
</script>
<style scoped>
.config-wrap {
    display: flex;
    align-items: flex-start;
}

.org-tree-card {
    width: 240px;
    flex-shrink: 0;
    margin-right: 10px;
    height: calc(100vh - 90px);
    overflow-y: auto;
}

.tree-title {
    font-weight: bold;
    margin-bottom: 10px;
}

.org-tree-card /deep/ .el-tree-node.is-current > .el-tree-node__content {
    background-color: #f2f3f5;
    color: #606266;
}

.node-label {
    display: flex;
    align-items: center;
}

.org-tree-card /deep/ .el-tree-node__expand-icon {
    display: none;
}

.xj-icon {
    width: 18px;
    height: 18px;
    margin-right: 5px;
    flex-shrink: 0;
}

.user-list-card {
    flex: 1;
    min-width: 0;
}

/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}
</style>
